import React, { Component } from "react";
import { connect } from "react-redux";
import { View, StyleSheet } from "react-native";
import Text from "../TextFont";
import * as Actions from "../../actions/AppWidgetActions";
import * as CONSTS from "../../../assets/consts";
import UserBalance from "./UserBalance";
/**@augments{Component<Props,state>} */
class WidgetContainer extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      accessToken: "",
    };
  }
  async componentDidMount() {
    var { accessToken } = this.props.appReducer.currentServer;
    this.setState({ accessToken });
  }

  handleOnAction = (widget, action) => {
    typeof this.props.onAction === "function" &&
      this.props.onAction(widget, action);
  };

  render() {
    return (
      <View {...this.props}>
        {this.props.WidgetReducer.widgets
          .filter((w) => w.enabled)
          .map((w, i) => {
            switch (w.name) {
              // all widgets component will call by their names
              case CONSTS.WIDGETS.USER_BALANCE:
                return (
                  <UserBalance
                    model={w}
                    key={i}
                    onAction={(action) => {
                      this.handleOnAction(CONSTS.WIDGETS.USER_BALANCE, action);
                    }}
                  />
                );
              default:
                return <Text key={i}>{w.name}</Text>;
            }
          })}
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WidgetReducer: state.AppWidgetReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAll: (accessToken) => {
      dispatch(Actions.getAll(accessToken));
    },
  };
};

const styles = StyleSheet.create({});

export default connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);
